import {AddIcon, CleanIcon} from "../../../../../components/buttons/IconButtons";
import HeadTittle from "../../../../../components/HeadTittle";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import DivContainerBody from "../../../../../components/DivContainerBody";
import React from "react";
import {permissionObj} from "../../../../../Helpers/permission";
import routes from "../../../../../Routes/routes";
import CreateVehicleMovementApp from "../../Functionality/VehicleMovements/CreateVehicleMovementApp";
import VehicleMovementSections from "./VehicleMovementSections";
import RequestInformationSection from "../EntryAndExitForms/RequestInformationSection";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Creation of a movement of a vehicle.
 *
 * The information every folio opens with is the one of the entry and exit
 * forms, and the sections of the movement are the ones of its own.
 */
const CreateVehicleMovement = () => {
    const {
        t,
        DEV,
        isGuard,
        permission,
        navigate,
        emptyFields,
        emptyFieldsItems,
        setEmptyFieldsItems,
        materialRequest,
        setMaterialRequest,
        handleChange,
        photoPicker,
        setPhotoPicker,
        selectedEmployees,
        setSelectedEmployees,
        watchers,
        setWatchers,
        responsibleDepartments,
        setResponsibleDepartments,
        resetForm,
        handleOnBack,
        handleAction
    } = CreateVehicleMovementApp();

    if (!DEV && !isGuard &&
        !permission?.includes(permissionObj.WEB_VEHICLE_MOVEMENTS_READ) &&
        !permission?.includes(permissionObj.WEB_VEHICLE_MOVEMENTS_CREATE)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                name={'create'}
                onBack={handleOnBack}
                divStack={
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_cvm_clean_all_inputs'
                        Icon={CleanIcon}
                        title={'clear_instances'}
                        onClick={() => {
                            resetForm();
                        }}
                    />
                }
            >
                { (DEV || permission?.includes(permissionObj?.WEB_VEHICLE_MOVEMENTS_CREATE)) &&
                    <ButtonAction
                        id='btn_cvm_create'
                        name={'create'}
                        className={'btn-icon-add'}
                        Icon={AddIcon}
                        onClick={() => {
                            handleAction();
                        }}
                    />
                }
            </HeadTittle>
            <DivContainerBody>
                <RequestInformationSection
                    t={t}
                    idPrefix={'cvm'}
                    materialRequest={materialRequest}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    selectedEmployees={selectedEmployees}
                    setSelectedEmployees={setSelectedEmployees}
                    watchers={watchers}
                    setWatchers={setWatchers}
                    responsibleDepartments={responsibleDepartments}
                    setResponsibleDepartments={setResponsibleDepartments}
                />

                <VehicleMovementSections
                    emptyFields={emptyFields}
                    materialRequest={materialRequest}
                    setMaterialRequest={setMaterialRequest}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    emptyFieldsItems={emptyFieldsItems}
                    setEmptyFieldsItems={setEmptyFieldsItems}
                />
            </DivContainerBody>
        </>
    );
};

export default CreateVehicleMovement;
